export const dash = {
	name: 'dash',
	title: 'Dash',
	content:
		'<path d="M 0.75,12.038h22.5" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
